import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getCalendarEventWithKey } from '../selectors/calendarFolderEventsSelectors';
import { isRecurringMaster } from 'owa-calendar-event-capabilities';
import { loadCalendarEvent } from '../services/loadCalendarEvent';
import { orchestrator } from 'satcheljs';
import {
    updateFullCalendarEventFromServer,
    fullCalendarEventLoaded,
} from '../actions/eventsCacheActions';

/**
 * Updates a full item in the full item cache, if needed after receiving a notification
 */
export const updateFullCalendarEventFromServerOrchestrator = orchestrator(
    updateFullCalendarEventFromServer,
    async actionMessage => {
        const partialCalendarEvent: CalendarEvent = actionMessage.partialCalendarEvent;
        const eventKey = isRecurringMaster(partialCalendarEvent.CalendarItemType)
            ? partialCalendarEvent.InstanceKey
            : partialCalendarEvent.ItemId.Id;
        const folderId = partialCalendarEvent.ParentFolderId.Id;

        if (getCalendarEventWithKey(eventKey, folderId)) {
            // load full item and place in cache
            const fullCalendarEvent = await loadCalendarEvent(
                partialCalendarEvent.ItemId,
                folderId
            );

            // only update the cache if loadCalendarEvent returned a non-null event
            if (fullCalendarEvent) {
                fullCalendarEventLoaded(folderId, eventKey, fullCalendarEvent);
            }
        }
    }
);
